import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { QRCodeModule } from 'angularx-qrcode';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-qr-code-cta',
  standalone: true,
  imports: [CommonModule, QRCodeModule, RouterModule, AngularSvgIconModule],
  templateUrl: './qr-code-cta.component.html',
  styleUrls: ['./qr-code-cta.component.scss'],
})
export class QrCodeCtaComponent {
  public link: string;
  public expanded = false;
  public desktop = new BehaviorSubject<boolean>(true);  // Tracks desktop or mobile view
  private destroyed = new Subject<void>();              // Manages unsubscriptions
  public isMobile: boolean;
  public isAndroid: boolean;
  public isIOS: boolean;

  @Output()
  closeDialog = new EventEmitter<void>();

  @HostListener('click')
  public onClick() {
    this.goToAppStore();
    if (this.deviceDetector.isDesktop()) {
      this.expanded = true;
    }
  }

  @HostListener('mouseenter')
  public onMouseenter() {
    if (this.deviceDetector.isDesktop()) {
      this.expanded = true;
    }
  }

  @HostListener('mouseleave')
  public onMouseleave() {
    this.expanded = false;
  }

  constructor(
    private readonly router: Router,
    private readonly deviceDetector: DeviceDetectorService,
    private readonly responsive: BreakpointObserver // Inject BreakpointObserver
  ) {}

  private generateRedirectLink(): string {
    return 'https://hostelhop.io/api/download';
  }

  public goToAppStore() {
    window.location.href = this.generateRedirectLink();
  }

  ngOnInit() {

    this.isMobile = this.deviceDetector.isMobile();
    this.isAndroid = this.deviceDetector.os === 'Android';
    this.isIOS = this.deviceDetector.os === 'iOS';
    this.link = this.generateRedirectLink();

    // Responsive observer logic to detect screen size and adjust `desktop` observable
    this.responsive.observe([
      Breakpoints.XSmall,
    ])
    .pipe(
      takeUntil(this.destroyed) // Unsubscribe when component is destroyed
    )
    .subscribe(result => {
      if (result.matches) {
        this.desktop.next(false);  // Mobile view
      } else {
        this.desktop.next(true);   // Desktop view
      }
    });
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }

  public close() {
    this.closeDialog.emit();
  }

  redirectToPlayStore() {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.hostel_hop_inc.hostel_hop_mobile&hl=en_US';
  }

  // Method to redirect to the Apple App Store
  redirectToAppStore() {
    window.location.href = 'https://apps.apple.com/us/app/hostel-hop/id6473739477';
  }
}
